import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/icons/close_icon.svg'


const _hoisted_1 = { class: "horiz-center mx-auto max-w-1440px <sm:px-0 <sm:w-full <sm:block <sm:mt-30px px-200px <lg:px-100px <750:px-50px h-100vh <sm:h-auto" }
const _hoisted_2 = { class: "mx-auto h-360px <lg:px-50px <lg:mt-50px" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex items-center <lg:flex-col <lg:items-start" }
const _hoisted_5 = {
  key: 1,
  class: "horiz-center mt-100px <sm:mt-40px"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-24px ml-20px <sm:ml-10px <sm:text-14px" }
const _hoisted_8 = { class: "flex items-center <sm:hidden" }
const _hoisted_9 = {
  class: "hover:fill-hex-6664D6 fill-black",
  src: _imports_0,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_block = _resolveComponent("top-block")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_accent_button = _resolveComponent("accent-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_block, {
      close: "",
      class: "sm:hidden"
    }),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-48px uppercase font-500 mb-10px <lg:text-18px <lg:mb-5px" }, " заявка на создание кабинета ", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-24px uppercase <lg:text-14px mb-55px <lg:mb-40px" }, " Свяжемся с вами, все обсудим и поможем ", -1)),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (!_ctx.sent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_text_input, {
                  class: "w-270px block mb-35px <lg:mb-20px",
                  placeholder: "Имя",
                  error: _ctx.name === '' && _ctx.submitted,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitted = false)),
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
                  ],
                  modelValue: _ctx.name,
                  type: "text"
                }, null, 8, ["error", "modelValue"]),
                _createVNode(_component_text_input, {
                  type: "tel",
                  error: _ctx.phone === '' && _ctx.submitted,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitted = false)),
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event))
                  ],
                  modelValue: _ctx.phone,
                  class: "w-270px block mb-35px <sm:mb-20px",
                  placeholder: "Телефон"
                }, null, 8, ["error", "modelValue"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_accent_button, {
                    onClick: _ctx.buttonHandler,
                    class: "<lg:order-1 <lg:mt-15px <lg:h-18px h-22px mb-10px"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Отправить заявку")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-17px ml-45px leading-20px w-500px <lg:w-400px <sm:w-full <lg:text-12px <lg:ml-0 text-hex-7E7E7E" }, [
                    _createTextVNode(" Нажимая на кнопку, вы даете согласие на "),
                    _createElementVNode("a", {
                      class: "underline hover:text-hex-6664D6",
                      href: "https://e-rko.ru/privacy_policy.pdf"
                    }, "обработку персональных данных"),
                    _createTextVNode(" и соглашаетесь с "),
                    _createElementVNode("a", {
                      class: "underline hover:text-hex-6664D6",
                      href: "https://e-rko.ru/terms_of_use.pdf"
                    }, "пользовательским соглашением")
                  ], -1))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: 
              !_ctx.error
                ? require('../assets/icons/success_icon.svg')
                : require('../assets/icons/icon_error.svg')
            ,
                  class: "w-50px h-50px <sm:w-25px <sm:h-25px"
                }, null, 8, _hoisted_6),
                _createElementVNode("span", _hoisted_7, _toDisplayString(!_ctx.error ? "Заявка успешно отправлена" : _ctx.errorMessage), 1)
              ]))
        ]),
        _: 1
      })
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "spacer <sm:hidden" }, null, -1)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
            [_directive_svg_inline]
          ])
        ]),
        _: 1
      })
    ])
  ]))
}